"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Builder", {
  enumerable: true,
  get: function get() {
    return _Builder.Builder;
  }
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player.Player;
  }
});
Object.defineProperty(exports, "builderFields", {
  enumerable: true,
  get: function get() {
    return _settings.fields;
  }
});
Object.defineProperty(exports, "builderInitialValues", {
  enumerable: true,
  get: function get() {
    return _settings.initialValues;
  }
});
Object.defineProperty(exports, "builderValidate", {
  enumerable: true,
  get: function get() {
    return _settings.validate;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getDataDefinitions", {
  enumerable: true,
  get: function get() {
    return _settings.getDataDefinitions;
  }
});
Object.defineProperty(exports, "getMetrics", {
  enumerable: true,
  get: function get() {
    return _settings.getMetrics;
  }
});
Object.defineProperty(exports, "getMetricsPrefix", {
  enumerable: true,
  get: function get() {
    return _settings.getMetricsPrefix;
  }
});
Object.defineProperty(exports, "getPlayerInitialValue", {
  enumerable: true,
  get: function get() {
    return _settings2.getInitialValue;
  }
});
Object.defineProperty(exports, "icon", {
  enumerable: true,
  get: function get() {
    return _settings.icon;
  }
});
Object.defineProperty(exports, "playerValidate", {
  enumerable: true,
  get: function get() {
    return _settings2.validate;
  }
});
Object.defineProperty(exports, "ttsFields", {
  enumerable: true,
  get: function get() {
    return _settings.ttsFields;
  }
});
var _Builder = _interopRequireWildcard(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireWildcard(require("./Player"));
var _settings2 = require("./Player/settings.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// export these data for matrix
var _default = exports["default"] = {
  code: 'checkbox',
  name: 'Checkbox',
  labelField: 'question',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  builderValidate: _settings.validate,
  player: _Player["default"],
  getPlayerInitialValue: _settings2.getInitialValue,
  playerValidate: _settings2.validate,
  getMetricsPrefix: _settings.getMetricsPrefix,
  getDataDefinitions: _settings.getDataDefinitions,
  getMetrics: _settings.getMetrics,
  getDataConnectors: _settings.getDataConnectors,
  getDataConnectorsValues: _settings.getDataConnectorsValues,
  ttsFields: _settings.ttsFields,
  getTotalQuestionNumbers: function getTotalQuestionNumbers() {
    return 1;
  },
  hasPrintVersion: true
};